module.exports = __webpack_public_path__ + "static/media/anime.cb42d158.png";